import { Alert, Collapse, Stack } from "@mui/material";
import type {
  ReportAccessState,
  ReportKind,
  ReportSource,
  WorkbookFilter,
  WorkbookReportParameter,
} from "../../../../../../api/types/workbookRuns.types";
import useUserContext from "../../../../../../context/useUserContext";
import ReportAccessRestrictedAlert from "@entrilia/shared/components/reporting/workbook/ReportAccessRestrictedAlert";
import ReportIsDeletedAlert from "@entrilia/shared/components/reporting/workbook/ReportIsDeletedAlert";
import ConditionBlock from "./ConditionBlock";
import InfoBlock from "./InfoBlock";

interface Props {
  expanded: boolean;
  isReadonly: boolean;
  isDeleted: boolean;
  reportAccessState: ReportAccessState;
  clientCode: string;
  reportFilters: WorkbookReportParameter[];
  reportKind: ReportKind;
  reportSource: ReportSource;
  reportId: string;
  workbookFilters: WorkbookFilter[];
  reportType: string;
}
const WorkbookReportItemDetails = ({
  expanded,
  isReadonly,
  isDeleted,
  reportAccessState,
  clientCode,
  workbookFilters,
  reportFilters,
  reportKind,
  reportSource,
  reportId,
  reportType,
}: Props) => {
  const { clients } = useUserContext();
  const reportCompanyTitle = clients.find((client) => client.clientCode === clientCode)?.title ?? "";

  return (
    <Collapse in={expanded} sx={{ flexGrow: 1 }}>
      <Stack
        sx={(theme) => ({
          p: 1.5,
          borderTop: "1px solid " + theme.palette.divider,
          borderBottomLeftRadius: "4px",
          borderBottomRightRadius: "4px",
          bgcolor: "#FAFAFA",
          width: "100%",
        })}
      >
        {isReadonly && <ReportAccessRestrictedAlert />}
        {!isReadonly && isDeleted && <ReportIsDeletedAlert />}
        {!isReadonly &&
          !isDeleted &&
          reportAccessState?.isConfigurationValid === false &&
          reportAccessState?.message && (
            <Alert severity="warning" sx={{ mb: 2, width: "100%" }}>
              {reportAccessState.message}
            </Alert>
          )}
        <InfoBlock
          companyTitle={reportCompanyTitle}
          isReadonly={isReadonly}
          reportKind={reportKind}
          reportSource={reportSource}
          reportType={reportType}
          clientCode={clientCode}
        />
        <ConditionBlock filters={reportFilters} workbookFilters={workbookFilters} reportId={reportId} />
      </Stack>
    </Collapse>
  );
};

export default WorkbookReportItemDetails;
